const urls = {
    request: '/api/profile/request',
    verify: '/api/profile/verify',
    delete: '/api/profile/delete',
};
const _fetch = (url, method, data) => fetch(url, { method, headers: { 'Content-Type': 'application/json;charset=utf-8' }, body: JSON.stringify(data)});

const client = {
    request: (email, _delete= false) => _fetch(urls.request,_delete ? 'DELETE' : 'POST', { identifier: email }),
    delete: (email, code) => _fetch(urls.delete, 'DELETE', { identifier: email, secret: code }),
    verify: (email, code, _delete = false) => _fetch(_delete ? urls.request : urls.verify, _delete ? 'DELETE' : 'POST', { identifier: email, secret: code }),
};

export { client };
